var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M6.96 6.874a3.125 3.125 0 1 0-3.317 0C2.477 7.4 1.588 8.468 1.266 9.77c-.15.61.334 1.146.96 1.198.76.063 1.853.13 3.075.13a38 38 0 0 0 3.075-.13c.626-.052 1.11-.588.96-1.198-.323-1.303-1.211-2.37-2.377-2.897ZM17.168 15.207a3.125 3.125 0 1 0-3.317 0c-1.165.527-2.054 1.594-2.376 2.897-.151.61.334 1.146.96 1.198.76.064 1.852.13 3.074.13a38 38 0 0 0 3.075-.13c.626-.052 1.111-.588.96-1.198-.322-1.303-1.21-2.37-2.376-2.897Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M2.95 13.183a59 59 0 0 0 .128 2.452 2.1 2.1 0 0 0 1.959 1.958c.99.075 2.415.148 4.327.168M10.405 2.766c2.445 0 4.207.086 5.369.173a2.1 2.1 0 0 1 1.958 1.959c.057.76.114 1.778.146 3.077"
  }))));
};
export default SvgGroup;